import { StyledBone } from './StyledComponents';

import type { BoneTypes } from './StyledComponents';

type Props = {
  type?: BoneTypes;
  cover?: boolean;
  dark?: boolean;
  className?: string;
};

const Bone = ({ dark = false, type = 'line', cover = false, className = '' }: Props) => (
  <StyledBone cover={cover} light={!dark} dark={dark} type={type} className={className} />
);

export default Bone;
